import React, { useMemo, useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, Input, Row, Label } from "reactstrap";
import { useSelector } from "react-redux";
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table";
import ReactPaginate from "react-paginate";
import { COLUMNS_LOGS } from "../../constants/columns";
import * as BsIcons from "react-icons/bs";
import "./style.css";

const ModalLogsUsuario = ({ isOpen, toggle }) => {
  const logs = useSelector((state) => state.usuario.logs || []);

  const formatarData = (dataISO) => {
    if (!dataISO) return "-";
    const data = new Date(dataISO);
    return isNaN(data)
      ? "-"
      : data.toLocaleDateString("pt-BR", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        });
  };

  const obterDataParaOrdenacao = (dataISO) => {
    const data = new Date(dataISO);
    return isNaN(data) ? -Infinity : data.getTime();
  };

  const data = useMemo(() => {
    return logs.map((log) => ({
      dataHora: formatarData(log?.data),
      dataHoraOrdenacao: obterDataParaOrdenacao(log?.data),
      responsavel: log?.responsavel || "-",
      ip: log?.ip || "-",
      tipo: log?.tipo || "-",
      descricao: log?.descricao || "-",
    }));
  }, [logs]);

  const columns = useMemo(() => COLUMNS_LOGS, []);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    gotoPage,
    state,
    setPageSize
  } = useTable(
    {
      columns,
      data,
      initialState: { pageSize: 10 },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const { _ , pageSize } = state;
  const [initialPage, setInitialPage] = useState(false);
  const [selectedPage, setSelectedPage] = useState(null);
  const pageCount = Math.ceil(data.length / pageSize);

  const handlePageClick = (e) => {
    const pageSelected = e.selected;
    setInitialPage(false);
    setSelectedPage(pageSelected);
    gotoPage(pageSelected);
  };

  function handleInitialPage() {
    gotoPage(0);
    setInitialPage(true);
    setSelectedPage(0);
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg" centered>
      <ModalHeader toggle={toggle}> Histórico de Ações</ModalHeader>
      <ModalBody>
        <div className="table-responsive">
          <table className="table logs-table" {...getTableProps()}>
            <thead className="thead-custom">
              {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()} key={headerGroup.id}>
                  {headerGroup.headers.map((column) => (
                    <th
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                      key={column.id}
                    >
                      <span className="th-sort-content">
                        {column.render("Header")}
                        <span className="th-sort-icon">
                          {column.isSorted ? (
                            column.isSortedDesc ? (
                              <BsIcons.BsArrowDown />
                            ) : (
                              <BsIcons.BsArrowUp />
                            )
                          ) : (
                            <BsIcons.BsArrowDownUp />
                          )}
                        </span>
                      </span>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {page.length > 0 ? (
                page.map((row) => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()} key={row.id}>
                      {row.cells.map((cell) => (
                        <td {...cell.getCellProps()} key={cell.column.id}>
                          {cell.render("Cell")}
                        </td>
                      ))}
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="5" className="text-center">
                    Nenhum log encontrado.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <Row className="align-items-center justify-content-between pt-3 px-3">
          <div className="text-muted">
            Mostrando {page.length} de {data.length} registros
          </div>

          <div className="d-flex align-items-center gap-2">
            <Label className="mr-2 mb-0" for="pageSize">
              Itens por página:
            </Label>
            <Input
              id="pageSize"
              type="select"
              className="form-control-sm"
              style={{ width: "auto" }}
              value={pageSize}
              onChange={(e) => {
                setPageSize(Number(e.target.value));
                handleInitialPage();
              }}
            >
              {[10, 25, 100].map((size) => (
                <option key={size} value={size}>
                  {size}
                </option>
              ))}
            </Input>

            <ReactPaginate
              previousLabel={"<"}
              nextLabel={">"}
              breakLabel={"..."}
              breakClassName={"break-me"}
              initialPage={0}
              pageCount={pageCount}
              marginPagesDisplayed={2}
              pageRangeDisplayed={3}
              onPageChange={handlePageClick}
              containerClassName={"pagination"}
              activeClassName={"active"}
              forcePage={initialPage ? 0 : selectedPage}
            />
          </div>
        </Row>
      </ModalBody>
    </Modal>
  );
};

export default ModalLogsUsuario;
